import { useEffect, useState } from "react";

import PageLayout from "examples/LayoutContainers/PageLayout";
import api from "services/api";

import LandingNavbar from "./components/LandingNavbar";
import HeroSection from "./components/HeroSection";
import StatsSection from "./components/StatsSection";
import ServicesSection from "./components/ServicesSection";
import ComplaintSection from "./components/ComplaintSection";
import AccessSection from "./components/AccessSection";
import LandingFooter from "./components/LandingFooter";
import GallerySection from "./components/GallerySection";
import ServiceDetailDialog from "./components/ServiceDetailDialog";

function LandingPage() {
  const [statistik, setStatistik] = useState(null);
  const [loadingStats, setLoadingStats] = useState(true);
  const [layanan, setLayanan] = useState([]);
  const [loadingLayanan, setLoadingLayanan] = useState(true);
  const [sektorFilter, setSektorFilter] = useState("Semua");
  const [selectedLayanan, setSelectedLayanan] = useState(null);
  const [syarat, setSyarat] = useState([]);
  const [loadingSyarat, setLoadingSyarat] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [galeri, setGaleri] = useState([]);
  const [loadingGaleri, setLoadingGaleri] = useState(true);

  useEffect(() => {
    api
      .get("public/statistik")
      .then((res) => setStatistik(res.data?.data || null))
      .catch(() => setStatistik(null))
      .finally(() => setLoadingStats(false));

    api
      .get("jenis-izin?status=AKTIF")
      .then((res) => setLayanan(res.data?.data || []))
      .catch(() => setLayanan([]))
      .finally(() => setLoadingLayanan(false));

    api
      .get("public/galeri-aktivitas")
      .then((res) => setGaleri(res.data?.data || []))
      .catch(() => setGaleri([]))
      .finally(() => setLoadingGaleri(false));
  }, []);

  const handleViewDetail = (item) => {
    setSelectedLayanan(item);
    setDialogOpen(true);
    setSyarat([]);
    setLoadingSyarat(true);
    api
      .get(`jenis-izin/${item.id}/syarat`)
      .then((res) => setSyarat(res.data?.data || []))
      .catch(() => setSyarat([]))
      .finally(() => setLoadingSyarat(false));
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setSelectedLayanan(null);
    setSyarat([]);
  };

  return (
    <PageLayout background="white">
      <LandingNavbar />
      <HeroSection />
      <StatsSection statistik={statistik} loading={loadingStats} />
      <ServicesSection
        layanan={layanan}
        loading={loadingLayanan}
        sektorFilter={sektorFilter}
        onSektorChange={setSektorFilter}
        onViewDetail={handleViewDetail}
      />
      <ComplaintSection />
      <GallerySection items={galeri} loading={loadingGaleri} />
      <AccessSection />
      <LandingFooter />

      <ServiceDetailDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        layanan={selectedLayanan}
        syarat={syarat}
        loadingSyarat={loadingSyarat}
      />
    </PageLayout>
  );
}

export default LandingPage;
